export default "__VITE_ASSET__AlQ95N$q__"